export default __webpack_public_path__ + "a86dded031c303f12e74b4f7270dfcc2.png";